/**
 * @module constants/musicGenreLabels
 * @description
 *   Parent genre display labels + Parent · Sub formatter for music UI.
 *   Subgenre labels live in musicSubgenres.js (do not duplicate server
 *   similar-artist pool keys like hiphop / kpop).
 *
 * @see docs/GENRE_PACK_RESEARCH.md
 */

import { MUSIC_SUBGENRES_BY_PARENT } from './musicSubgenres';

/** Selectable parent ids → UI labels. Keep aligned with server MUSIC_GENRE_LABELS. */
export const MUSIC_GENRE_LABELS = {
  pop: 'Pop',
  hip_hop: 'Hip Hop',
  electronic: 'Electronic',
  'r&b': 'R&B',
  rock: 'Rock',
  country: 'Country',
  instrumental: 'Instrumental',
  latin: 'Latin',
  afrobeats: 'Afrobeats',
  k_pop: 'K-Pop',
  indie: 'Indie',
};

function titleCaseId(value) {
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Parent id → Hip Hop. Unknown ids title-case; empty → ''. */
export function formatParentGenreLabel(genre) {
  if (genre == null || !String(genre).trim()) return '';
  const key = String(genre).trim().toLowerCase();
  if (MUSIC_GENRE_LABELS[key]) return MUSIC_GENRE_LABELS[key];
  return titleCaseId(genre);
}

function lookupSubgenreLabel(parent, sub) {
  if (sub == null || !String(sub).trim()) return null;
  const subKey = String(sub).trim().toLowerCase().replace(/-/g, '_');
  const parentKey = parent != null ? String(parent).trim().toLowerCase() : '';
  const parentList = MUSIC_SUBGENRES_BY_PARENT[parentKey];
  if (Array.isArray(parentList)) {
    const hit = parentList.find((opt) => opt.id === subKey);
    if (hit) return hit.label;
  }
  for (const list of Object.values(MUSIC_SUBGENRES_BY_PARENT)) {
    const hit = list.find((opt) => opt.id === subKey);
    if (hit) return hit.label;
  }
  return titleCaseId(sub);
}

/**
 * Selection chrome: Hip Hop, or Hip Hop · Trap when a subgenre is set.
 * @param {string|null|undefined} parent
 * @param {string|null|undefined} [sub]
 * @returns {string}
 */
export function formatMusicGenreDisplay(parent, sub) {
  const parentLabel = formatParentGenreLabel(parent);
  const subLabel = lookupSubgenreLabel(parent, sub);
  if (parentLabel && subLabel) return `${parentLabel} · ${subLabel}`;
  if (parentLabel) return parentLabel;
  if (subLabel) return subLabel;
  return '—';
}
